import React, { useMemo, useState } from "react";
import { IntendedUsePageContent } from "@swo/storefront";
import { GenericFacetedFilter } from "../../components/_shared-components/generic-listing-page/GenericFacetedFilter";
import { ActivatedFacets, Facet, FilterValue } from "../../components/_shared-components/generic-listing-page/types";
import { OpenedFacetTab } from "../../components/_shared-components/generic-listing-page/OpenedFacetTab";
import { getConfig } from "./getConfig";
import { firstFromNullable } from "../../components/_shared-components/generic-listing-page/firstFromNullable";
import { IntendedUseCards } from "./IntendedUseCards";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import { useGeneralTranslationsContext } from "../../global/hooks/use-general-translations-context";
import { T } from "../../components/T";

export const openedFilterTabByFilterKey: string | undefined = "category";
export const IS_FETCHING = false;

export const IntendedUseResultsWithFilter: React.FC<{
  items: IntendedUsePageContent["items"];
}> = ({ items }) => {
  const t = useGeneralTranslationsContext();

  const categoryLabel = t("categoryLabel");
  const filterLabel = t("filterLabel");

  const { facets } = useMemo(() => getConfig(items, categoryLabel), [items]);

  const [activatedFacets, setActivatedFacets] = useState<ActivatedFacets>({
    [openedFilterTabByFilterKey]: [],
  });

  const onClick = (facet: Facet) => {
    // console.log(facet);
  };

  const filterValues = facets.find(f => f.__key === openedFilterTabByFilterKey)?.values;

  const isChecked =
    (facetKey: string) =>
    (v: FilterValue): boolean => {
      return !!activatedFacets[facetKey] && firstFromNullable(activatedFacets[facetKey]) === v.value.toString();
    };

  const onFilterValueClicked =
    (openedFilterTabByFilterKey: string) =>
    (value: FilterValue): void => {
      const current = new Set(activatedFacets[openedFilterTabByFilterKey]);
      const t = value.value?.toString();
      const nextValue: Array<string> = Array.from(getNext());

      function getNext(): Set<string> {
        if (current.has(t)) {
          const ret = new Set(current);
          ret.delete(t);

          return ret;
        } else {
          return new Set(current).add(t);
        }
      }

      setActivatedFacets({ ...activatedFacets, [openedFilterTabByFilterKey]: nextValue });
    };

  const openedFacetTab =
    openedFilterTabByFilterKey && filterValues ? (
      <OpenedFacetTab
        activatedFacets={activatedFacets}
        filterValues={filterValues}
        colorsCssMap={{}}
        openedFilterTabByFilterKey={openedFilterTabByFilterKey}
        inputType={"checkbox"}
        isChecked={isChecked(openedFilterTabByFilterKey)}
        onFilterValueClicked={onFilterValueClicked(openedFilterTabByFilterKey)}
        allowMultipleSelection={true}
      />
    ) : null;

  return (
    <>
      {facets.length > 0 && facets.some(f => f.values.length > 0) && (
        <div
          className="u-inline-flex"
          css={css`
            ${CSS_MQ.atMostSm} {
              width: 100%;
            }
          `}
        >
          <GenericFacetedFilter
            isFetching={IS_FETCHING}
            label={<T>{filterLabel}</T>}
            activatedFacets={activatedFacets}
            facets={facets}
            onClick={onClick}
            openedFilterTabByFilterKey={openedFilterTabByFilterKey}
          >
            {openedFacetTab}
          </GenericFacetedFilter>
        </div>
      )}

      <IntendedUseCards
        items={items}
        activeProductCategoryFilters={activatedFacets[openedFilterTabByFilterKey] ?? []}
      />
    </>
  );
};
